import useFranchiseHook from "@/shared/hooks/useFranchiseHook";
import useGenerateImageUrl from "@/shared/hooks/useGenerateImageUrl";
import useKioskSettingsQuery from "@/shared/queries/kioskSettings/useKioskSettingsQuery";
import {
  DEFAULT_IMAGE_ID,
  imageType,
} from "../Settings/WebsiteSettings/Settings";

const KioskLogo = (props: any) => {
  const [franchiseId] = useFranchiseHook();
  const kioskSettingsQuery = useKioskSettingsQuery();
  const generateImageUrl = useGenerateImageUrl();
  const logo = kioskSettingsQuery.data?.logo;
  const src =
    logo && logo !== DEFAULT_IMAGE_ID
      ? generateImageUrl(logo, imageType.LOGO, franchiseId)
      : "";
  return <img src={src} {...props} />;
};

export default KioskLogo;
